// config.prod.js
module.exports = {
    ENVIRONMENT: 'mainnet',
    PROJECT_ID: 'c679f6063761066df4de699e48a8459b',
    MULTIVERSX_API_URL: 'https://api.multiversx.com',
    MULTIVERSX_EXPLORER_URL: 'https://explorer.multiversx.com',
    API: 'https://api.ta-da.io/',
    COLLECTION_ID: 'TADABONDZ-de50b6',
    VESTING_CONTRACT: 'erd1qqqqqqqqqqqqqpgqtjrtf98xcyca4mwjq6hauv3qsy0xef0e449qtdzdme',
};
